export default Object.freeze({
    AllowForNoResponse: 'AllowForNoResponse',
    Date: 'Date',
    Email: 'Email',
    Geolocation: 'Geolocation',
    HierarchyForceLowestLevel: 'HierarchyForceLowestLevel',
    Login: 'Login',
    MaxDiff: 'MaxDiff',
    MaxLength: 'MaxLength',
    MultiCount: 'MultiCount',
    MultiSum: 'MultiSum',
    Numeric: 'Numeric',
    OtherRequired: 'OtherRequired',
    Precision: 'Precision',
    Range: 'Range',
    Ranking: 'Ranking',
    Required: 'Required',
    RequiredIfOtherSpecified: 'RequiredIfOtherSpecified',
    Scale: 'Scale',
});
